import { Outlet } from 'react-router-dom';

import { GuardInterview } from '@/features/auth';
import { InterviewLayout } from '@/features/interview';

export const InterviewRootLayout = () => {
  return (
    <GuardInterview>
      <InterviewLayout>
        <Outlet />
      </InterviewLayout>
    </GuardInterview>
  );
};
